import * as _ from 'lodash'
import { action, observable, computed, toJS } from 'mobx'
import { backend } from '../api'
import {
  Order
} from '../resources'

export default class AdminStore {
  @observable private orderLoaded: boolean
  @observable private order: Order

  private nullOrder = {
    uuid: null,
    orderId: null,
    contactDetails: {
      greeting:  null,
      firstName: null,
      lastName:  null,
      email: null,
      phone: null
    },
    customerAgent: {
      name: null,
      photo: null
    },
    creationDate: null,
    planningReason: null,
        location: {
        city:  null,
        label:  null,
        zipCode:  null,
        latitude:  null,
        longitude:  null,
        province:  null,
        available:  null,
        displayCategories: null,
        },
    products: null
  }

  constructor() {
    this.orderLoaded = false
    this.order = this.nullOrder
  }

  initWithOrderId(orderId: string) {
    this.findOfferByOrderId(orderId).then(() => {
      this.init()
    })
  }

  private init = () => {
    //console.log(this.order.products.length);
  }
  get getOrder() {
    return toJS(this.order)
  }
  
  @action findOfferByOrderId = (orderId: any) => {
    return backend.findOfferByOrderId(orderId, (result) => {
      if (result) {
          //console.log("Backend",result)
        this.setOrder(result)
        this.orderLoaded = true
      }
    })
  }

  @computed get isAllLoaded() {
    return this.orderLoaded
  }

  
  @action setOrder = (orderInput: Order) => {
    this.order = orderInput;
    this.orderLoaded = true
    //console.log(this.order)
    }
}



// WEBPACK FOOTER //
// ./src/stores/AdminStore.ts